export const SUPPORT_ACCESS_DENIED_MESSAGE =
  "Your signed-in account does not have PalSync support access. Ask a PalSync administrator to grant the required support role, then retry.";

export const isSupportAccessDenied = (value) => {
  if (Number(value?.status) === 403) return true;

  const message = typeof value === "string" ? value : value?.message;
  return message === SUPPORT_ACCESS_DENIED_MESSAGE;
};
